/**Dependencies */
import React, { useState } from "react";

/**Components */

import { CardCarrousel } from "../components/CardCarrousel";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Slider from "react-slick";
import Badge from "react-bootstrap/Badge";
import Accordion from "react-bootstrap/Accordion";

/**Images */
import imgSirenis from "../images/img-sirenis.png";
import imgRoyalton from "../images/img-royalton.png";
import imgRiu from "../images/img-riu.png";
import iconVisa from "../images/icons/icon-VISA.png";
import iconMC from "../images/icons/icon-mastercard.png";
import iconAmex from "../images/icons/icono-amex.png";
import iconPayU from "../images/icons/icon-PayU.png";
import iconStripe from "../images/icons/icon-Stripe.png";
import iconDiscover from "../images/icons/icon-discover.png";
import imgTransportation from "../images/icons/icon-transportation.png";
import imgFood from "../images/icons/icon-food.png";
import imgStar from "../images/icons/star-purple.png";

/**Styles */
import "../styles/components/fichaTours.scss";

export const FichaTours = () => {
  const [destinies] = useState([
    {
      hotel: "Grand Sirenis Punta Cana Resort & Aquagame",
      location: "Punta Cana, Rep. Dom",
      price: "$000,000",
      days: "10",
      img: imgSirenis,
    },
    {
      hotel: "Grand Sirenis Punta Cana Resort & Aquagame",
      location: "Punta Cana, Rep. Dom",
      price: "$000,000",
      days: "10",
      img: imgRoyalton,
    },
    {
      hotel: "Grand Sirenis Punta Cana Resort & Aquagame",
      location: "Punta Cana, Rep. Dom",
      price: "$000,000",
      days: "10",
      img: imgRiu,
    },
  ]);

  const settings = {
    customPaging: function (i) {
      return (
        <a>
          <img src={`https://picsum.photos/id/${i + 1}/30/30`} />
        </a>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  const settingsActivities = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <div className="section-info-activie container py-5">
        <Row>
          <Col lg={4} md={6} sm={12} className="margin-mobile">
            <div className="slider-container">
              <Slider {...settings}>
                <div className="d-flex justify-content-center">
                  <img src={"https://picsum.photos/id/1/400/500"} />
                </div>
                <div>
                  <img src={"https://picsum.photos/id/2/400/500"} />
                </div>
                <div>
                  <img src={"https://picsum.photos/id/3/400/500"} />
                </div>
                <div>
                  <img src={"https://picsum.photos/id/4/400/500"} />
                </div>
              </Slider>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="d-flex">
              <h3
                className="text-rose"
                style={{ fontSize: "35px", fontWeight: 600 }}
              >
                Recorrido Torre Eifel
              </h3>
              <div style={{ marginLeft: "12px" }}>
                <img src={imgStar} alt="" width={25} />
                <img src={imgStar} alt="" width={25} />
                <img src={imgStar} alt="" width={25} />
                <img src={imgStar} alt="" width={25} />
                <img src={imgStar} alt="" width={25} />
                <span
                  className="text-secondary mt-1"
                  style={{ fontSize: "11px" }}
                >
                  (5.0)
                </span>
              </div>
            </div>
            <span style={{ fontWeight: "600" }}>París, Francia</span>
            <div className="py-3">
              <Badge bg="secondary">+5 Horas</Badge>
              <Badge bg="light" style={{ marginLeft: "18px", color: "black" }}>
                Inglés - Español
              </Badge>
              <Badge bg="light" style={{ marginLeft: "18px", color: "black" }}>
                Urbano
              </Badge>
            </div>
            <div>
              <Accordion defaultActiveKey="0" flush>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Descripción de la actividad
                  </Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Itinerario de la actividad
                  </Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Incluye</Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>No incluye</Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
        </Row>
      </div>
      <div className="section-select-activitie container py-5">
        <Row className="horizontal-ticket">
          <div className="ticket">
            <Col lg={1} md={4} sm={12}>
              <div className="barcode-section">
                <div className="barcode"></div>
              </div>
            </Col>

            <Col lg={4} md={4} sm={12}>
              <div className="left-section">
                <p
                  className=" text-purple"
                  style={{ fontSize: "24px", fontWeight: 600 }}
                >
                  Recorrido Torre Eiffel
                </p>
                <p className="location text-purple">París, Francia</p>

                <p>Nuestras formas de pago:</p>
                <div className="payment-methods">
                  <img src={iconVisa} alt="Visa" />
                  <img src={iconMC} alt="American Express" />
                  <img src={iconAmex} alt="PayU" />
                  <img src={iconPayU} alt="PayPal" />
                  <img src={iconStripe} alt="Stripe" />
                  <img src={iconDiscover} alt="Discover" />
                </div>
              </div>
            </Col>
            <Col lg={3} md={4} sm={12}>
              <div className="people-section">
                <h4 className="text-purple">Personas</h4>
                <div className="people-type">
                  <span className="text-purple">Adultos</span>
                  <div className="counter">
                    <button className="btn-purple">-</button>
                    <input type="text" value="2" readonly />
                    <button className="btn-purple">+</button>
                  </div>
                </div>
                <div className="people-type">
                  <span className="text-purple">Menores</span>
                  <div className="counter">
                    <button className="btn-purple">-</button>
                    <input type="text" value="2" readonly />
                    <button className="btn-purple">+</button>
                  </div>
                </div>
                <br />
                <span className="text-purple">Incluir</span>
                <div className="include-section">
                  <div className="include-item">
                    <label>
                      Alimentos{" "}
                      <img
                        src={imgFood}
                        alt=""
                        width={25}
                        style={{ marginTop: "-12px" }}
                      />
                    </label>
                    <input type="checkbox" className="toggle" />
                  </div>
                  <div className="include-item">
                    <label>
                      Traslado{" "}
                      <img
                        src={imgTransportation}
                        alt=""
                        width={25}
                        style={{ marginTop: "-12px" }}
                      />
                    </label>
                    <input type="checkbox" className="toggle" />
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <div className="price-section">
                <h4 className="text-purple">Precio Total</h4>
                <p className="text-rose" style={{ fontSize: "20px" }}>
                  USD $0,000.00
                </p>
                <span className="text-secondary span-price">
                  Precio por persona
                </span>{" "}
                <p className="text-secondary"> $0,000.00 USD</p>
                <div className="d-flex justify-content-end">
                  <Button className="btn-purple">Reservar</Button>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </div>

      <div className="section-cards-hotel container py-5">
        <h1 className="text-purple text-center pb-5">
          Mira estas <strong className="text-rose">actividades</strong> en el
          mismo destino
        </h1>
        <Row>
          <Slider {...settingsActivities}>
            {destinies.map((dataHotel, index) => {
              return (
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  key={index + 1}
                  className="d-flex justify-content-center pt-4"
                >
                  <CardCarrousel dataInfo={dataHotel} />
                </Col>
              );
            })}
          </Slider>
        </Row>
      </div>
    </div>
  );
};
